import { createFileRoute, Link, Outlet, useParams } from '@tanstack/react-router'
import { useBreadcrumbs } from '../../hooks/useBreadcrumbs'
import { mdiMapMarker  } from '@mdi/js'
import { AppIcon } from '../../components/ui/icon'
import { PageHeader } from '../../components/shared/PageHeader'
import { SECTION_ICONS } from '../../lib/section-icons'

export const Route = createFileRoute('/$org/debug')({
  component: DebugLayout,
})

function DebugLayout() {
  const { org } = useParams({ from: '/$org/debug' })

  useBreadcrumbs([
    { title: 'Home', path: `/${org}` },
    { title: 'Debug' },
  ])

  return (
    <div className="container mx-auto py-8 max-w-4xl">
      <PageHeader className="mb-6" icon={SECTION_ICONS.debug} title="Debug" />
      <div className="grid gap-4 md:grid-cols-2">
        <Link
          to="/$org/assets/all"
          params={{ org }}
          search={{ asset_type_uid: undefined }}
          className="flex items-center gap-3 rounded-lg border border-border p-4 hover:bg-accent transition-colors"
          data-testid="debug-all-assets"
        >
          <AppIcon path={SECTION_ICONS.assets} size="md" />
          <div>
            <div className="font-medium">All Assets</div>
            <div className="text-sm text-muted-foreground">Flat list of all assets</div>
          </div>
        </Link>
        <Link
          to="/$org/contracts"
          params={{ org }}
          className="flex items-center gap-3 rounded-lg border border-border p-4 hover:bg-accent transition-colors"
          data-testid="debug-contracts"
        >
          <AppIcon path={SECTION_ICONS.contracts} size="md" />
          <div>
            <div className="font-medium">Contracts</div>
            <div className="text-sm text-muted-foreground">Contract management</div>
          </div>
        </Link>
        <Link
          to="/$org/debug/annotations"
          params={{ org }}
          className="flex items-center gap-3 rounded-lg border border-border p-4 hover:bg-accent transition-colors"
          data-testid="debug-annotations"
        >
          <AppIcon path={mdiMapMarker} size="md" />
          <div>
            <div className="font-medium">Annotations</div>
            <div className="text-sm text-muted-foreground">Pin annotations on document images</div>
          </div>
        </Link>
      </div>
      <Outlet />
    </div>
  )
}
